import { Controller } from '@hotwired/stimulus'

// Dark mode for the dashboard. Applies the `dark` class on <html> from the
// user's preference (light / dark / system), persisted in localStorage and
// kept in sync across Turbo navigations (connect runs each visit) and live OS
// changes when in "system" mode.
//
// Attached to <body> in the dashboard layout. `data-theme-disabled="true"`
// (the template editor) forces light. The pre-paint <head> script handles the
// initial full-load flash; this controller owns everything after.
const MEDIA = '(prefers-color-scheme: dark)'
const VALID = ['light', 'dark', 'system']

export default class extends Controller {
  static targets = ['option']

  connect() {
    this.boundSystem = () => { if (this.mode === 'system') this.apply() }
    window.matchMedia(MEDIA).addEventListener('change', this.boundSystem)
    this.apply()
    this.refreshOptions()
  }

  disconnect() {
    window.matchMedia(MEDIA).removeEventListener('change', this.boundSystem)
  }

  get disabled() {
    return this.element.dataset.themeDisabled === 'true'
  }

  get mode() {
    const stored = localStorage.getItem('theme')
    return VALID.includes(stored) ? stored : 'system'
  }

  // Invoked from the user-menu options: data-action="theme#set" data-theme-mode-param="dark"
  set(event) {
    const mode = event.params.mode
    if (!VALID.includes(mode)) return
    localStorage.setItem('theme', mode)
    this.apply()
    this.refreshOptions()
  }

  apply() {
    if (this.disabled) {
      document.documentElement.classList.remove('dark')
      return
    }
    const dark = this.mode === 'dark' || (this.mode === 'system' && window.matchMedia(MEDIA).matches)
    document.documentElement.classList.toggle('dark', dark)
  }

  refreshOptions() {
    const current = this.mode
    this.optionTargets.forEach((el) => {
      const active = el.dataset.mode === current
      el.classList.toggle('is-active', active)
      const check = el.querySelector('[data-theme-check]')
      if (check) check.classList.toggle('hidden', !active)
    })
  }
}
